import { ImageHash } from '@root/entities/currency'
import { Socials } from '@root/entities/socials'

import { PremiumId } from './premium-id'
import * as PremiumOwner from './premium-owner'

import type { ServicesGetTokenMetaListData } from '@blade/trade-api-client'
import type { ServicesApi } from '@root/shared/api'
import type {
  AvatarsHost,
  TokenBannersHost,
  TokenLogosHost,
} from '@root/shared/models'

export type PremiumProduct = 'subscription' | 'boosters'
export type Status = ServicesApi.PremiumMetaDto['status']

export type ArchivedStatus = 'archived' | 'expired' | 'failed'
export type ArchivedPremiumDto = NonNullable<
  ServicesGetTokenMetaListData['premium']['archivedPremiums']
>[number]

export interface ArchivedPremium {
  premiumId: PremiumId
  status: ArchivedStatus
  archivedAt: Date
  reason: string
  note: string | undefined
  expiresAt: Date
  logo: string | undefined
  imageHash: ImageHash | undefined
  banner: string | undefined
  socials: Socials.Socials
  portalLink: string | undefined
  owner: PremiumOwner.PremiumOwner | undefined
}

export const archivedPremiumFromDto = (
  dto: ArchivedPremiumDto,
  options: {
    avatarsHost: AvatarsHost
    tokenLogosHost: TokenLogosHost
    tokenBannersHost: TokenBannersHost
  },
): ArchivedPremium => {
  return {
    premiumId: PremiumId(dto.premiumId),
    status: dto.status,
    archivedAt: new Date(dto.archivedAt),
    reason: dto.reason,
    note: dto.note,
    expiresAt: new Date(dto.expiresAt),
    logo: dto.logo ? `${options.tokenLogosHost}/${dto.logo}` : undefined,
    imageHash:
      'imageHash' in dto && typeof dto.imageHash === 'string'
        ? ImageHash(dto.imageHash)
        : undefined,
    banner: dto.banner
      ? `${options.tokenBannersHost}/${dto.banner}`
      : undefined,
    socials: dto.socials ? Socials.fromDto(dto.socials) : Socials.empty(),
    portalLink: dto.banner,
    owner: dto.ownerDelugeId
      ? PremiumOwner.fromDto(dto, options.avatarsHost)
      : undefined,
  }
}
